<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // 当前项目版本号，发布新版本时修改此处
    const currentVersion = '1.0.1'; // 每次发布更新时修改这个版本号
    const storedVersion = localStorage.getItem('appVersion');
    
    // 如果本地存储的版本号和当前项目版本号不一致，强制刷新页面
    if (storedVersion !== currentVersion) {
      localStorage.setItem('appVersion', currentVersion); // 更新版本号到 localStorage
      location.reload(true); // 强制刷新页面，加载最新资源
    }
  }
};
</script>

<style>
#app {
  height: 98vh;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue